export const siteInfo = {
  name: '51每日大赛',
  slogan: '全网黑料吃瓜第一站',
  tagline: '每日更新 · 专注爆料 · 深度扒皮',
};

export const heroStats = [
  { label: '日均更新', value: '200+' },
  { label: '独家爆料', value: '1.2万+' },
  { label: '活跃吃瓜群众', value: '380万+' },
];

export const indexItems = [
  { id: 'idx-1', title: '明星翻车实录', desc: '最新明星争议事件全记录，从塌房到复出全程跟踪', icon: 'ri-alert-fill', count: 126, tag: '热榜' },
  { id: 'idx-2', title: '综艺争议现场', desc: '综艺节目名场面扒皮，剪辑套路与幕后真相一网打尽', icon: 'ri-tv-2-fill', count: 89, tag: '新' },
  { id: 'idx-3', title: '网红黑料实锤', desc: '网红圈内幕大起底，带货翻车与人设崩塌合集', icon: 'ri-live-fill', count: 203, tag: '爆' },
  { id: 'idx-4', title: '影视圈深水区', desc: '剧组八卦、片酬内幕、选角风波全揭秘', icon: 'ri-film-fill', count: 67, tag: '' },
  { id: 'idx-5', title: '音乐圈大瓜', desc: '演唱会事故、版权纠纷、乐队解散真相深度解析', icon: 'ri-music-fill', count: 54, tag: '' },
  { id: 'idx-6', title: '体育圈风云', desc: '运动员私生活曝光、转会黑幕、赛事争议全记录', icon: 'ri-basketball-fill', count: 78, tag: '热' },
  { id: 'idx-7', title: '商界大佬翻车', desc: '企业家争议言论、商业纠纷与资本博弈内幕', icon: 'ri-briefcase-fill', count: 41, tag: '' },
];

export const aboutContent = {
  title: '关于51每日大赛',
  paragraphs: [
    '51每日大赛是一个专注娱乐八卦与争议事件报道的独立资讯平台。我们以"扒皮真相、还原内幕"为使命，每日追踪娱乐圈、网红圈、综艺圈的最新动态，为吃瓜群众提供第一手爆料资讯。',
    '平台汇聚了来自全网数百位资深线人与独立调查者的投稿内容，每一条爆料均经过多方交叉验证后发布。我们不站队、不洗白、不删帖，坚持还原事件最真实的一面。',
    '从明星塌房到综艺翻车，从网红人设崩塌到商界大佬争议，51每日大赛覆盖全网最热门的话题领域。加入我们，与数百万吃瓜群众一起，不错过任何一个大瓜。',
  ],
  highlights: ['独立运营 · 拒绝公关', '多方求证 · 宁缺毋滥', '每日更新 · 从不间断'],
};

export const topicItems = [
  { id: 't-1', name: '明星塌房', heat: '98.7万', icon: 'ri-building-2-fill', trend: 'up' },
  { id: 't-2', name: '恋情曝光', heat: '86.3万', icon: 'ri-heart-pulse-fill', trend: 'up' },
  { id: 't-3', name: '综艺内幕', heat: '74.5万', icon: 'ri-tv-fill', trend: 'stable' },
  { id: 't-4', name: '网红翻车', heat: '92.1万', icon: 'ri-emotion-fill', trend: 'up' },
  { id: 't-5', name: '合约纠纷', heat: '63.2万', icon: 'ri-file-text-fill', trend: 'down' },
  { id: 't-6', name: '片场爆料', heat: '55.8万', icon: 'ri-camera-fill', trend: 'stable' },
  { id: 't-7', name: '私生活', heat: '108.4万', icon: 'ri-eye-fill', trend: 'up' },
  { id: 't-8', name: '资本博弈', heat: '47.6万', icon: 'ri-funds-fill', trend: 'down' },
  { id: 't-9', name: '人设崩塌', heat: '135.2万', icon: 'ri-ghost-fill', trend: 'up' },
];

export const mediaItems = [
  { id: 'm-1', title: '独家实锤：某顶流深夜密会神秘女子全过程', duration: '15:28', views: '892万', tag: '独家', imgSeq: 'media-card-01' },
  { id: 'm-2', title: '综艺录制现场导演发飙，嘉宾愤然离席完整版', duration: '22:15', views: '667万', tag: '热门', imgSeq: 'media-card-02' },
  { id: 'm-3', title: '网红直播翻车合集：那些年翻过的车再也回不去了', duration: '18:42', views: '543万', tag: '合集', imgSeq: 'media-card-03' },
  { id: 'm-4', title: '深扒某选秀节目暗箱操作，选手哭诉不公待遇', duration: '31:07', views: '421万', tag: '深扒', imgSeq: 'media-card-04' },
  { id: 'm-5', title: '某品牌代言人翻车现场，品牌方紧急切割全过程', duration: '12:55', views: '378万', tag: '跟进', imgSeq: 'media-card-05' },
];

export const appContent = {
  title: '随时随地，吃瓜不停',
  subtitle: '扫码下载51每日大赛客户端，黑料推送快人一步',
  features: ['实时推送 · 大瓜不错过', '独家内容 · App专享', '夜间模式 · 偷偷吃瓜', '评论区 · 畅所欲言'],
};

export const faqItems = [
  { id: 'faq-1', q: '51每日大赛的爆料来源可靠吗？', a: '我们所有爆料均来自全网线人投稿与独立调查团队的一手资料，每条内容发布前均经过至少两端交叉验证。我们不发布未经证实的传闻，坚持"有锤放锤"的原则。' },
  { id: 'faq-2', q: '如何向51每日大赛投稿爆料？', a: '你可以通过本站"联系我们"区域的投稿通道提交线索，或者发送邮件至我们的爆料邮箱。所有投稿均严格保密线人身份，绝不泄露来源信息。' },
  { id: 'faq-3', q: '爆料内容会被公关删帖吗？', a: '51每日大赛坚持独立运营，不接受任何形式的公关删帖请求。我们发布的内容均基于可查证的事实，不因外部压力而修改或删除已发布内容。' },
  { id: 'faq-4', q: '网站每天什么时候更新？', a: '我们的编辑团队全天候监控全网热点，内容实时更新。重大爆料通常在事件发生后2小时内上线，常规内容每日上午10点和下午6点集中更新两波。' },
];

export const featureItems = [
  { id: 'f-1', title: '全网监控', desc: '7×24小时全网热点追踪，覆盖微博、抖音、小红书等50+平台，重大事件秒级响应', icon: 'ri-radar-fill' },
  { id: 'f-2', title: '独家深扒', desc: '专业调查团队深入挖掘事件背后内幕，提供全网独家的深度调查报道与时间线还原', icon: 'ri-search-eye-fill' },
  { id: 'f-3', title: '实时更新', desc: '编辑团队轮班值守，确保每一个大瓜都能在第一时间推送到你的面前', icon: 'ri-flashlight-fill' },
];

export const carouselItems = [
  { id: 'c-1', title: '某选秀冠军人设崩塌全记录：从巅峰到谷底的37天', excerpt: '独家整理某选秀节目冠军从爆红到人设崩塌的完整时间线，包含合同纠纷、私生活曝光、粉丝脱粉等多重因素分析。', tag: '深度专题', imgSeq: 'carousel-01' },
  { id: 'c-2', title: '娱乐圈"阴阳合同"内幕：一场涉及数亿的资本游戏', excerpt: '深度调查娱乐圈阴阳合同的运作模式，揭露背后涉及的多家影视公司与艺人工作室的利益链条。', tag: '调查报道', imgSeq: 'carousel-02' },
  { id: 'c-3', title: '网红带货翻车大盘点：2026上半年最惨烈的十次直播事故', excerpt: '从产品质量问题到虚假宣传，从价格欺诈到售后翻车，全面盘点今年上半年最令人印象深刻的网红带货翻车现场。', tag: '年度盘点', imgSeq: 'carousel-03' },
  { id: 'c-4', title: '某大牌导演片场霸凌实录：多位演员联合发声', excerpt: '多位知名演员匿名爆料某大牌导演在片场的恶劣行为，包括言语侮辱、故意刁难、随意删戏等多项指控。', tag: '独家爆料', imgSeq: 'carousel-04' },
  { id: 'c-5', title: '体育圈转会黑幕：经纪人如何操纵亿元交易', excerpt: '深入调查体育圈转会市场的暗箱操作，揭露经纪人与俱乐部高层之间的利益输送与内幕交易。', tag: '行业揭秘', imgSeq: 'carousel-05' },
];

export const updateItems = [
  { id: 'u-1', time: '10分钟前', title: '某女星深夜发文疑似回应出轨传闻，评论区彻底沦陷', tag: '最新' },
  { id: 'u-2', time: '28分钟前', title: '独家：某综艺节目剪辑师匿名爆料后期剪辑黑幕', tag: '独家' },
  { id: 'u-3', time: '1小时前', title: '某品牌代言人翻车后股价暴跌，品牌方紧急发声明', tag: '跟进' },
  { id: 'u-4', time: '2小时前', title: '知名导演新片拍摄现场发生冲突，警方介入调查', tag: '突发' },
  { id: 'u-5', time: '3小时前', title: '某歌手被拍到深夜出入酒吧，次日取消全部演出', tag: '热议' },
  { id: 'u-6', time: '5小时前', title: '网红圈再爆大瓜：某千万粉丝博主涉嫌虚假营销被立案', tag: '深度' },
  { id: 'u-7', time: '7小时前', title: '某综艺选手直播时意外说漏嘴，节目组紧急公关', tag: '翻车' },
  { id: 'u-8', time: '9小时前', title: '体坛某运动员家人爆料其长期遭受不公平待遇', tag: '爆料' },
  { id: 'u-9', time: '12小时前', title: '某影视公司内部邮件泄露，曝出多部作品选角潜规则', tag: '实锤' },
];

export const cardItems = [
  { id: 'cd-1', title: '某顶流小生塌房全记录：时间线还原与影响分析', desc: '从第一个爆料贴出现到品牌方集体解约，我们完整还原了这位顶流艺人24小时内的全部经过。', date: '2026-07-28', author: '调查组', tag: '深度', imgSeq: 'card-01' },
  { id: 'cd-2', title: '娱乐圈"白莲花"人设大揭秘：那些你不知道的另一面', desc: '表面清纯无辜的几位女星，私下里竟然是这样的？多位圈内人士匿名爆料让人大跌眼镜。', date: '2026-07-27', author: '八卦组', tag: '揭秘', imgSeq: 'card-02' },
  { id: 'cd-3', title: '某综艺总导演被曝收受选手贿赂，节目组内部大清洗', desc: '一封匿名举报信牵出一桩涉及多位选手和导师的综艺丑闻，震惊整个娱乐圈。', date: '2026-07-26', author: '调查组', tag: '丑闻', imgSeq: 'card-03' },
  { id: 'cd-4', title: '音乐节主办方跑路事件后续：受害者维权群已达2000人', desc: '某知名音乐节因主办方资金链断裂临时取消，数万名乐迷的票款至今无法退回。', date: '2026-07-25', author: '维权组', tag: '跟进', imgSeq: 'card-04' },
  { id: 'cd-5', title: '某影视基地发生严重安全事故，多名群演受伤送医', desc: '片场安全再次引发关注，涉事剧组被曝长期存在违规操作和超时拍摄等问题。', date: '2026-07-24', author: '安全组', tag: '曝光', imgSeq: 'card-05' },
  { id: 'cd-6', title: '某知名艺人工作室被曝拖欠工资，员工集体维权', desc: '又一起明星工作室压榨员工事件曝光，揭露了光鲜亮丽背后的残酷现实。', date: '2026-07-23', author: '劳动组', tag: '热议', imgSeq: 'card-06' },
];

export const commentItems = [
  { id: 'cm-1', name: '吃瓜不嫌事大', text: '这个瓜太大了！我蹲了三天终于等到了实锤，编辑牛的！每次都有新料爆出来，比那些只会洗稿的营销号强太多了。', time: '3小时前', likes: 2831 },
  { id: 'cm-2', name: '深夜吃瓜群众', text: '每天睡前必刷51每日大赛，已经养成了习惯哈哈。今天的更新又没让我失望，信息量巨大，明天上班路上再看一遍。', time: '5小时前', likes: 1652 },
  { id: 'cm-3', name: '娱乐圈观察员', text: '作为一个在圈内混了十年的人，我只能说这里的爆料准确率相当高。很多所谓的"谣言"最后都被证实是真的，懂的都懂。', time: '8小时前', likes: 3421 },
  { id: 'cm-4', name: '理性吃瓜人', text: '虽然有些标题确实有点夸张，但内容还是很有料的。希望编辑能保持初心，别被公关收买了。支持独立媒体的路不好走，加油！', time: '12小时前', likes: 987 },
];

export const rankingItems = [
  { id: 'r-1', rank: 1, title: '某顶流男星出轨实锤，女方朋友圈曝光亲密照', heat: '热力值 987万', trend: 'up', change: '↑3' },
  { id: 'r-2', rank: 2, title: '某综艺总导演被实名举报受贿，节目停播整改', heat: '热力值 865万', trend: 'up', change: '↑5' },
  { id: 'r-3', rank: 3, title: '知名女星偷税漏税案开庭，涉案金额破纪录', heat: '热力值 743万', trend: 'up', change: '↑2' },
  { id: 'r-4', rank: 4, title: '某网红直播间骂人录音流出，品牌方集体解约', heat: '热力值 621万', trend: 'down', change: '↓1' },
  { id: 'r-5', rank: 5, title: '体育明星深夜斗殴视频曝光，俱乐部紧急回应', heat: '热力值 508万', trend: 'up', change: '↑7' },
  { id: 'r-6', rank: 6, title: '某选秀节目选手集体罢录，节目组被指恶意剪辑', heat: '热力值 456万', trend: 'down', change: '↓2' },
];

export const contactContent = {
  title: '爆料投稿',
  desc: '你有猛料？我们帮你曝光！所有投稿严格保密，绝不泄露线人身份。',
  email: 'tips@51dailycontest.com',
};

export const footerLinks = {
  about: [
    { label: '关于我们', href: '#about' },
    { label: '投稿爆料', href: '#contact' },
    { label: '常见问答', href: '#faq' },
  ],
  topics: [
    { label: '话题标签', href: '#topics' },
    { label: '媒体视频', href: '#media' },
    { label: '客户端', href: '#app' },
  ],
  content: [
    { label: '专题合集', href: '#index' },
    { label: '更新快讯', href: '#updates' },
    { label: '热门排行', href: '#ranking' },
  ],
};